module.exports = __webpack_public_path__ + "static/media/July_2026_2.03f1fe7b.webp";